<template>
  <div class="pjdy-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.orderType" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.all_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分派工厂"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.factory_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="计划交期"
                    width="170"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.planned}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="排产人"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.schedule_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="排产时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.schedule_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="色板来源"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.color_source}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="配件数量"
                    width="150"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.barmark===1||scope.row.barmark===0">计算中</span>
                      <span v-if="scope.row.barmark===2" style="font-weight: 500;color:#409EFF">{{scope.row.accessnum}}</span>
                    </template>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    label="配件数量/已出库"-->
<!--                    width="150"-->
<!--                    align="center"-->
<!--                    fixed="right"-->
<!--                    show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                      <span v-if="scope.row.barmark===1||scope.row.barmark===0">计算中</span>-->
<!--                      <span v-if="scope.row.barmark===2" style="font-weight: 500;color:#409EFF">{{scope.row.accessnum}}</span>-->
<!--                      <span v-if="scope.row.barmark===2">/</span>-->
<!--                      <span v-if="scope.row.barmark===2" style="font-weight: 500;color:#f56c6c">{{scope.row.outedaccessnum}}</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-finished" @click.stop="out(scope.row)">立即出库</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editPackTitle"
      :visible.sync="editPackVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div style="padding-bottom: 20px;padding-left: 20px;padding-right: 20px">
        <el-form :inline="true" size="small" :model="searchAccessForm">
          <el-form-item label="搜索关键字">
            <el-input v-model="searchAccessForm.search" @keyup.enter.native="getAccess"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getAccess" icon="el-icon-search">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :key="tableKey"
          :data="materialTableData"
          style="width: 100%"
          v-loading="materialloading"
          stripe
          @selection-change="handleAccessSelectionChange"
          size="small">
          <el-table-column type="selection" :selectable='checkboxInfoT' align="center" width="50"></el-table-column>
          <el-table-column prop="xuhao" align="center" show-overflow-tooltip width="80" label="序号"></el-table-column>
          <el-table-column prop="area" label="区域" width="100" show-overflow-tooltip :resizable="false"></el-table-column>
          <!--            <el-table-column prop="type" align="center" show-overflow-tooltip width="90" label="分类"></el-table-column>-->
          <el-table-column prop="name" width="120" show-overflow-tooltip align="center" label="名称"></el-table-column>
          <el-table-column prop="material" align="center" show-overflow-tooltip width="90" label="基材"></el-table-column>
          <el-table-column label="规格" width="120" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
              <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
              <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
              <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
              <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="num" align="center" show-overflow-tooltip width="80" label="数量"></el-table-column>
          <el-table-column prop="unit" align="center" show-overflow-tooltip width="60" label="单位"></el-table-column>
          <el-table-column prop="color" width="120" show-overflow-tooltip label="颜色" align="center"></el-table-column>
          <el-table-column prop="remark" min-width="100" show-overflow-tooltip label="备注" align="center"></el-table-column>
          <el-table-column label="出库状态" fixed="right" width="90" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :disable-transitions="true" v-if="scope.row.omark===1">已出库</el-tag>
              <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.omark===0">未出库</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-form size="small" ref="editPackForm" :model="editPackForm" :rules="editPackRules" label-width="80px">
        <el-form-item label="配件包号" prop="packnum">
          <el-input v-model="editPackForm.packnum" placeholder="请自定义输入此次出库的包号" maxlength="100" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="editPackForm.tel" style="width: 200px" maxlength="11" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="editPackForm.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="editPackForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="subPackOut" :loading="fullscreenLoading" icon="el-icon-finished">立即出库</el-button>
          <el-button size="small" @click="editPackVisible=false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpOrderAccessoriesList, getOrderProductList, accessOutStock, exportPartsOutList } from '@/api/erp'

export default {
  name: 'pjck',
  computed: {
    user: getUser
  },
  data() {
    return {
      exportLoading: false,
      searchForm: {
        search: '',
        orderType: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editPackForm: {
        orderid: '',
        packnum: '',
        tel: '',
        address: '',
        remark: ''
      },
      editPackTitle: '',
      editPackVisible: false,
      searchAccessForm: {
        search: ''
      },
      tableKey: '',
      materialloading: false,
      materialTableData: [],
      editPackRules: {
        packnum: [{ required: true, message: '请输入配件包号', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        address: [{ required: true, message: '请输入送货地址', trigger: 'blur' }]
      },
      fullscreenLoading: false,
      multipleAccessSelection: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          content: this.searchForm.search,
          groupid: this.user.dGroupid,
          mark: '13,100',
          userid: this.user.dUserid,
          role: this.user.role,
          ispjck: 1,
          type: this.searchForm.orderType,
          tableName: '配件出库'
        }
        exportPartsOutList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    out(row) {
      this.editPackForm.orderid = row.order_id
      this.editPackForm.packnum = ''
      this.editPackForm.tel = row.custtel
      this.editPackForm.address = row.address
      this.editPackTitle = row.product_num + ' 配件出库'
      this.searchAccessForm.search = ''
      this.multipleAccessSelection = []
      this.editPackVisible = true
      this.getAccess()
    },
    getAccess() {
      this.materialTableData = []
      this.materialloading = true
      const data = {
        orderid: this.editPackForm.orderid,
        content: this.searchAccessForm.search
      }
      getErpOrderAccessoriesList(data).then(response => {
        this.tableKey = new Date().getTime()
        this.materialTableData = response.data
        this.materialloading = false
      }).catch(() => {
        this.materialloading = false
      })
    },
    subPackOut() {
      let accessData = []
      for (const m of this.multipleAccessSelection) {
        if (m.omark === 0) {
          accessData.push(m)
        }
      }
      if (accessData.length <= 0) {
        this.$message.error('至少选择一个配件')
        return
      }
      this.$refs[`editPackForm`].validate((valid) => {
        if (valid) {
          if (!this.fullscreenLoading) {
            this.$confirm('此操作将出库此 ' + accessData.length + ' 个配件, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.fullscreenLoading = true
              let mdids = []
              for (const d of accessData) {
                mdids.push(d.mdid)
              }
              const data = {
                orderid: this.editPackForm.orderid,
                userid: this.user.dUserid,
                mdids: mdids.join(','),
                address: this.editPackForm.address,
                tel: this.editPackForm.tel,
                remark: this.editPackForm.remark,
                packnum: this.editPackForm.packnum
              }
              accessOutStock(data).then(response => {
                this.fullscreenLoading = false
                this.$message({
                  message: '出库成功',
                  type: 'success'
                })
                this.editPackVisible = false
                this.getData()
              }).catch(() => {
                this.fullscreenLoading = false
              })
            }).catch(() => {})
          }
        } else {
          return false
        }
      })
    },
    checkboxInfoT(row, rowIndex) {
      if (row.omark === 1) {
        return false
      } else {
        return true
      }
    },
    handleAccessSelectionChange(val) {
      this.multipleAccessSelection = val
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    changeMark(n) {
      if (n === this.mark) {
        return false
      } else {
        this.mark = n
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        mark: '13,100',
        userid: this.user.dUserid,
        role: this.user.role,
        ispjck: 1,
        type: this.searchForm.orderType,
        process: 13
      }
      getOrderProductList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.pjdy-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
